"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.noop = exports.URL_REGEX = void 0;
exports.extractUrls = extractUrls;
exports.sanitizeMobileNumber = sanitizeMobileNumber;
exports.sleep = sleep;
exports.encodeMobileNumber = encodeMobileNumber;
exports.isDefined = isDefined;
exports.randomUUID = randomUUID;
exports.sortAvailabilityBlocks = sortAvailabilityBlocks;
exports.createAvailabilityBlocksText = createAvailabilityBlocksText;
exports.escapeRegex = escapeRegex;
exports.omit = omit;
const uuid_1 = require("uuid");
const smart_date_1 = require("./smart-date/smart.date");
const lang_utils_1 = require("./lang.utils");
exports.URL_REGEX = /(https?:\/\/[^\s]+|www\.[^\s]+|[\w.-]+\.[a-z]{2,}(?:\/[^\s]*)?)/i;
function extractUrls(text) {
    if (!text)
        return [];
    const parts = text.split(exports.URL_REGEX);
    return parts
        .filter((part) => part.length > 0)
        .map((part) => {
        const isUrl = exports.URL_REGEX.test(part);
        let normalizedUrl = undefined;
        if (isUrl) {
            normalizedUrl = part;
            if (!normalizedUrl.startsWith('http://') && !normalizedUrl.startsWith('https://')) {
                normalizedUrl = `https://${normalizedUrl}`;
            }
        }
        return {
            original: part,
            isUrl,
            normalizedUrl,
        };
    });
}
function sanitizeMobileNumber(mobile) {
    if (mobile === '99333999999') {
        return mobile;
    }
    let mobileNumber = mobile;
    if (mobileNumber.startsWith('+')) {
        mobileNumber = mobileNumber.replace('+', '');
    }
    if (mobileNumber.startsWith('98')) {
        mobileNumber.replace('98', '0');
    }
    if (!mobileNumber.startsWith('0')) {
        mobileNumber = `0${mobileNumber}`;
    }
    if (mobileNumber.length !== 11 || Number.isNaN(Number(mobileNumber))) {
        return undefined;
    }
    return mobileNumber;
}
async function sleep(timeout) {
    return new Promise((resolve) => {
        setTimeout(() => {
            resolve(1);
        }, timeout);
    });
}
function encodeMobileNumber(mobile) {
    return (0, lang_utils_1.numbersToPersian)(`${mobile.slice(7, 14)}***${mobile.slice(0, 4)}`);
}
function isDefined(value) {
    return value !== null && value !== undefined;
}
function randomUUID() {
    return (0, uuid_1.v4)();
}
const noop = () => { };
exports.noop = noop;
function sortAvailabilityBlocks(availabilities) {
    return availabilities.reduce((total, block) => {
        total[block.dayOfWeek] = total[block.dayOfWeek] || [];
        total[block.dayOfWeek].push(block);
        return total;
    }, {});
}
function createAvailabilityBlocksText(availabilities) {
    let text = '';
    const list = sortAvailabilityBlocks(availabilities);
    Object.keys(list).forEach((day) => {
        const blocks = list[Number(day)];
        text = text.concat(`${(0, lang_utils_1.dayNumberToString)(day)} => `).concat(blocks
            .map((b) => {
            const { startTime, endTime } = (0, smart_date_1.smartDate)().blockTimeInJalali(b);
            return `${startTime} تا ${endTime}`;
        })
            .join(', '));
        text = text.concat(`\n`);
    });
    return text;
}
function escapeRegex(text) {
    return text.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&');
}
function omit(obj, keys) {
    const result = { ...obj };
    keys.forEach((key) => {
        delete result[key];
    });
    return result;
}
